import React, { PropsWithChildren } from 'react';
import {useAsync} from "react-async-hook";
import {config} from "../../libs/config/config";

export const PlainLayout: React.FC = ({
                                          children,
                                        }: PropsWithChildren<any>) => {
  useAsync(
    async () => {
      document.title = config.app.room.name;
    },
    []);

  return (
    <>
      {children}
    </>
  );
};
